/* ck-ymm.js — YMM landing router
 * Depends on ck-core.js (window.CK).
 *
 * Flow:
 *   1. Read vehicle (year|make|model) from section data attributes.
 *   2. Fetch submodels for that vehicle via CK.getSubmodels.
 *   3. On confirm: store vehicle via CK.setVehicle, then navigate to
 *      /products/<selected-material-handle>. The destination generic PDP
 *      picks up the vehicle from cookies and enforces material constraints.
 *
 * No add-to-cart, no map lookups — the material <select>'s option value
 * IS the destination handle (rendered by Liquid).
 */
(function () {
  'use strict';

  if (!window.CK) { return; }
  var root = document.querySelector('[data-ck-ymm]');
  if (!root) { return; }

  var picker    = root.querySelector('[data-ck-picker]');
  if (!picker) { return; } // family unresolvable — Liquid rendered fallback only

  var submodel  = picker.querySelector('[data-ck-submodel]');
  var material  = picker.querySelector('[data-ck-material]');
  var confirm   = picker.querySelector('[data-ck-confirm]');
  var fallback  = picker.querySelector('[data-ck-fallback]');

  var parts = (root.dataset.vehicle || '').split('|');
  var year = parts[0], make = parts[1], model = parts[2];
  var baseVehicle = '';
  var subs = [];

  function showFallback() {
    fallback.hidden = false;
    submodel.hidden = true;
    material.hidden = true;
    confirm.hidden = true;
  }

  function refreshGate() {
    var okSub = subs.length <= 1 || submodel.value !== '';
    confirm.disabled = !(okSub && material.value !== '');
  }

  picker.dataset.state = 'loading';
  CK.getSubmodels(year, make, model).then(function (res) {
    picker.dataset.state = '';
    baseVehicle = res.baseVehicle || '';
    subs = res.subModels || [];
    submodel.innerHTML = '';
    if (subs.length <= 1) {
      submodel.closest('.ck-ymm__field').hidden = true;
    } else {
      var opt0 = new Option('Select a submodel…', '');
      submodel.add(opt0);
      subs.forEach(function (s) { submodel.add(new Option(s, s)); });
      submodel.disabled = false;
    }
    refreshGate();
  }).catch(showFallback);

  submodel.addEventListener('change', refreshGate);
  material.addEventListener('change', refreshGate);

  picker.addEventListener('submit', function (e) {
    e.preventDefault();
    if (confirm.disabled) { return; }
    var chosenSub = subs.length === 1 ? subs[0] : submodel.value;
    CK.setVehicle({
      year: year, make: make, model: model,
      submodel: chosenSub || '',
      baseVehicle: baseVehicle
    });
    window.location.assign('/products/' + material.value);
  });
})();
